<template>
  <div class="ld-nav-bar ld-nav-bar-main">
    <!-- Nav button one - Home -->
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <div class="ld-nav-bar-item" v-on="on" @click="onClickNav1">
          <v-icon>home</v-icon>
        </div>
      </template>
      <span>Lollicup Denver</span>
    </v-tooltip>
    <!-- Nav button two - About -->
    <v-tooltip right>
      <template v-slot:activator="{on}">
        <div class="ld-nav-bar-item" v-on="on" @click="onClickNav2">
          <v-icon>group</v-icon>
        </div>
      </template>
      <span>About</span>
    </v-tooltip>
    <!-- Nav button three - Menu -->
    <v-tooltip right>
      <template v-slot:activator="{on}">
        <div class="ld-nav-bar-item" v-on="on" @click="onClickNav3">
          <v-icon>local_drink</v-icon>
        </div>
      </template>
      <span>Menu</span>
    </v-tooltip>
    <!-- Nav button four - Gallery -->
    <v-tooltip right>
      <template v-slot:activator="{on}">
        <div class="ld-nav-bar-item" v-on="on" @click="onClickNav4">
          <v-icon>photo_camera</v-icon>
        </div>
      </template>
      <span>Gallery</span>
    </v-tooltip>
    <!-- Nav button one - Contact -->
    <v-tooltip right>
      <template v-slot:activator="{on}">
        <div class="ld-nav-bar-item" v-on="on" @click="onClickNav5">
          <v-icon>location_on</v-icon>
          </div>
      </template>
      <span>Contact</span>
    </v-tooltip>
  </div>
</template>

<script>
  export default {
    methods: {
      onClickNav1: function(element) {
        this.$emit('onClickNav1', element);
      },

      onClickNav2: function(element) {
        this.$emit('onClickNav2', element);
      },

      onClickNav3: function(element) {
        this.$emit('onClickNav3', element);
      },

      onClickNav4: function(element) {
        this.$emit('onClickNav4', element);
      },

      onClickNav5: function(element) {
        this.$emit('onClickNav5', element);
      }
    },

    name: 'navigationComponentMain',

    data() {
      return {};
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/navigation_main_component.vue